import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const pad2 = (n) => String(n).padStart(2, '0');

// Date.toISOString() converts to UTC first, which silently shifts the date
// back a day for any positive UTC offset (e.g. Spain, CET/CEST) — "June 1st
// 00:00 local" becomes "2026-05-31" once serialized. Building the string from
// the Date object's own local year/month/day avoids that conversion entirely.
// Use this instead of `date.toISOString().split('T')[0]` for any date-only
// value (filters, "today", filenames) — reserve toISOString() itself for
// actual timestamps where UTC is correct.
export const toLocalISODate = (date) => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
